import { decode as base64_decode, encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";

import Cookies from "js-cookie";
import utf8 from "utf8";
import moment from "moment";
class SecureTrackVehicleStore {
  vehicles = [];
  total = 0;
  loading = false;

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      vehicles: observable,
      total: observable,
      loading: observable,
      loadData: action
    });
    this.rootStore = rootStore;
  }

  async loadData({
    userId,
    companyId
  }) {
    this.loading = true;

    var postData = {
      userId:userId,
      companyId:companyId
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicletracking&a=getVehiclesSecureTrack", "postData=" + base64Input);

    console.log(response);
   // console.log("company Data", response?.data?.data?.companydata);
    var vehiclesData = response?.data?.data;



    Object.keys(vehiclesData).map((e, i) => {
      let r = vehiclesData[i];

      //  var diff = new Date(r.currtime) - new Date(r.updatedate);
      const diff = moment(r.currtime).diff(r.updatedate, "minutes");
      var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
      if (diff >= 90) {
        vehiclesData[i].listImage = vehicleTypeNew + "-gray.png";
        vehiclesData[i].rowBackground = "gray";
        vehiclesData[i].currentStatus = "nodata";
      } else if (r.acc == 1 && r.speed == 0) {
        //idle)
        vehiclesData[i].listImage = vehicleTypeNew + "-yellow.png";
        vehiclesData[i].rowBackground = "yellow";
        vehiclesData[i].currentStatus = "idle";
      } else if (r.acc == 0) {
        vehiclesData[i].listImage = vehicleTypeNew + "-red.png";
        vehiclesData[i].rowBackground = "red";
        vehiclesData[i].currentStatus = "stop";
      } else if (r.acc == 1 && r.speed > 0) {
        vehiclesData[i].listImage = vehicleTypeNew + "-green.png";
        vehiclesData[i].rowBackground = "green";
        vehiclesData[i].currentStatus = "running";
      }
      vehiclesData[i].mapImage = vehiclesData[i].listImage;

      try {
        require("../assets/images/detailtracking/" +
          vehiclesData[i].listImage);
      } catch (err) {
        vehiclesData[i].listImage = "car-icon-blue.png";
      }

      try {
        require("../assets/images/livetracking/" +
          vehiclesData[i].mapImage);
      } catch (err) {
        vehiclesData[i].mapImage = "car-icon-blue.png";
      }
    });
    console.log('vehiclesData',vehiclesData);
    this.vehicles = vehiclesData;

    this.loading = false;
    return  this.vehicles;
  } 
}

export default SecureTrackVehicleStore;
